import qs from 'query-string';

const parseQueryString = (query: string) => (query ? qs.parse(query) : {});

const addParams = (search: string, params: { [x: string]: string }) => {
  const urlParams = qs.parse(search);
  const withNew = { ...urlParams, ...params };
  const hydratedSearch = qs.stringify(withNew);
  return hydratedSearch ? `?${hydratedSearch}` : '';
};

const removeParams = (search: string, params: string | string[]): string => {
  const parsedSearch = qs.parse(search);
  params = typeof params === 'string' ? [params] : params;
  params.forEach(key => {
    delete parsedSearch[key];
  });
  const filteredSearch = qs.stringify(parsedSearch);
  return filteredSearch === '' ? filteredSearch : `?${filteredSearch}`;
};

export { parseQueryString, addParams, removeParams };
